import { scaffoldState } from "undo-redo-vuex";

const filters = [];

const isSaved = false;

const status = "";

const error = null;

const initialLoad = false;

export default scaffoldState({
  filters,
  isSaved,
  status,
  error,
  initialLoad
});
